
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/holiday",
      function () {
        return require("private-next-pages/holiday/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/holiday"])
      });
    }
  